import { occFetch, occUrl } from "~/app/api/occ/occFetch";
import type { RequestAQuoteFormData } from "../components/RequestAQuoteDialog/RequestAQuoteDialog";
import { toProductConfiguratorPDFDataWsDTO, type ProductConfiguratorPDFData } from "./apiGenerateDatasheet";

interface RequestAQuotePayload {
  formData: RequestAQuoteFormData;
  pdfData: ReturnType<typeof toProductConfiguratorPDFDataWsDTO>;
  quantity: number;
  appId: string | null;
}

export async function apiRequestAQuote(
  productCode: string,
  quantity: number,
  formData: RequestAQuoteFormData,
  pdfData: ProductConfiguratorPDFData,
  appId: string | null,
) {
  const url = occUrl(`/configurator/${productCode}/contact-form/submit`);

  const payload: RequestAQuotePayload = {
    formData,
    pdfData: toProductConfiguratorPDFDataWsDTO(pdfData),
    quantity,
    appId,
  };

  const response = await occFetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    throw new Error(`Failed to request quote: ${response.statusText}`);
  }
}
